import { fetchClientUserProfileAPI } from "api/apiHelper";
import { AppDispatch } from "app/store";
import { setClientProfile, setProfileError } from "./reducer";

export const setClientProfileDetails = () => async (dispatch: AppDispatch) => {
  try {
    let response = await fetchClientUserProfileAPI();
    if (response?.data) {
      let profileInfo = {
        id: response.data?.id,
        clientId: response.data?.client_id,
        clientName: response.data?.client_name || "",
        userId: response.data?.user_id,
        username: response.data?.username || "",
        email: response.data?.email || "",
        firstName: response.data?.first_name || "",
        lastName: response.data?.last_name || "",
        fullName: `${response.data?.first_name || ""} ${response.data?.last_name || ""}`.trim() || response.data?.username || "",
        jobTitle: response.data?.job_title || null,
        photoUrl: response.data?.photo || null,
        isActive: response.data?.is_active !== undefined ? response.data.is_active : true,
        loading: false,
      };
      dispatch(setClientProfile(profileInfo));
    }
  } catch (error: any) {
    console.log(error);
    dispatch(setProfileError(error));
  }
};
